import { StyleDeclarationValue, css } from 'aphrodite';
import { RatingGraphic } from '../../../web/components/svgs/graphics/RatingGraphic';
import { SurveyHeader } from '../../components/surveys/SurveyHeader';
import { Survey } from '../Survey';
import { styleSheet } from './styles';

interface IProps {
	className?: string;
	styles?: StyleDeclarationValue[];
}

export function SurveyUnavailable({ className = '', styles = [] }: IProps) {
	const onRenderHeader = () => {
		return <SurveyHeader name='Survey' />;
	};
	return (
		<Survey
			className={`survey-unavailable-container ${className || ''}`}
			styles={styles}
			onRenderHeader={onRenderHeader}
		>
			<div className={css(styleSheet.unavailable)}>
				<RatingGraphic />
				<div>This survey is not available at this time.</div>
			</div>
		</Survey>
	);
}
